/* -----------------------------------------------------------------
 *                 FULLSCREEN ZOOM + DRAG FOR JS
 * ----------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {

  /* ── CONSTANTS ───────────────────────────────────────────── */
  const DESKTOP_EXTRA = 1.5;
  const DRAG_THD      = 6;
  const OPEN_DIST     = 40;
  const RESET_DIST    = 40;
  const CLOSE_DIST    = 35;
  const MIN_S         = 1;
  const MAX_S         = 4;

  const DECELERATION    = 0.002;
  const MIN_VELOCITY    = 0.15;

  const SEL_IMG   = '.zoom-gallery .zoom-media img';
  const SEL_MODAL = '.zoom-gallery.modal';
  const SEL_ARROW = '[data-gridy-arrow]';
  const SEL_CLOSE = '[data-modal-close]';

  const isMobile = matchMedia('(pointer:coarse)').matches;
  isMobile ? initMobile() : initDesktop();


  /* ==============================================================
              .mobile-modal-open
 * ============================================================ */
(() => {
  const SLIDER_SELECTOR = '.product-media-slider';
  const TRACK_SELECTOR  = '.gridy-track';
  const BTN_SELECTOR    = '.mobile-modal-open';

  document.querySelectorAll(BTN_SELECTOR).forEach(btn => {
    btn.addEventListener('click', e => {
      const slider = e.target.closest(SLIDER_SELECTOR);
      const track  = slider?.querySelector(TRACK_SELECTOR);
      if (!slider || !track) return;

      /* current slides (.product-media) */
      const slides = Array.from(track.querySelectorAll('.product-media'));

      const center = track.scrollLeft + track.clientWidth / 2;
      const current = slides.reduce((closest, slide) => {
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        return Math.abs(slideCenter - center) <
               Math.abs((closest.offsetLeft + closest.offsetWidth / 2) - center)
               ? slide : closest;
      });

      const targetId = current.id.replace(/^item-/, 'modal-item-');

      /* ID modal href buttin */
      const modalSel = btn.getAttribute('href');          // #modal--zoom-gallery-...
      const modal    = document.querySelector(modalSel);
      const mTrack   = modal?.querySelector(TRACK_SELECTOR);
      const mItem    = modal?.querySelector('#' + targetId);
      if (!modal || !mTrack || !mItem) return;

      /* smooth open */
      modal.classList.add('is-preparing');
      mTrack.scrollLeft = mItem.offsetLeft - mTrack.offsetLeft;
      requestAnimationFrame(() => {
        modal.classList.remove('is-preparing');
        modal.classList.add   ('is-active');
      });
    });
  });
})();

  /* ==========================================================
   *       DESKTOP
   * ======================================================== */
  function initDesktop(){
    const map=new Map();
    document.querySelectorAll(SEL_IMG).forEach(img=>{
      const wrap=img.closest('.zoom-item');
      img.style.transformOrigin='center center';

      const st={zoom:false,pan:false,moved:false,
                sc:1,x:0,y:0,sx:0,sy:0,fRect:null,iRect:null,raf:null};
      map.set(img,st);

      const T=b=>img.style.transition=b?'transform .3s ease':'none';
      const apply=()=>img.style.transform =
        st.zoom?`translate3d(${st.x}px,${st.y}px,0) scale(${st.sc})`:'';
      const clamp=()=>{
        const maxX=(st.iRect.width *st.sc-st.fRect.width )/2;
        const maxY=(st.iRect.height*st.sc-st.fRect.height)/2;
        st.x=Math.max(-maxX,Math.min(st.x,maxX));
        st.y=Math.max(-maxY,Math.min(st.y,maxY));apply();
      };
      function reset(){
        st.zoom=false;st.sc=1;st.x=st.y=0;st.moved=false;
        img.classList.remove('zoomed');img.style.cursor='zoom-in';
        T(true);img.style.transform='';
      }
      img.addEventListener('resetZoom',reset);

      img.addEventListener('click',e=>{
        if(st.moved){st.moved=false;return;}
        if(!st.zoom){
          st.fRect=wrap.getBoundingClientRect();
          st.iRect=img.getBoundingClientRect();
          st.sc=Math.max(st.fRect.width /st.iRect.width,
                         st.fRect.height/st.iRect.height)*DESKTOP_EXTRA;
          st.x=st.y=0;st.zoom=true;
          img.classList.add('zoomed');img.style.cursor='grab';
          T(true);apply();clamp();
        }else reset();
      });

      img.addEventListener('pointerdown',e=>{
        if(!st.zoom)return;
        e.preventDefault();img.setPointerCapture(e.pointerId);
        st.pan=true;st.moved=false;
        st.sx=e.clientX-st.x;st.sy=e.clientY-st.y;
        T(false);img.style.cursor='grabbing';
      },{passive:false});

      img.addEventListener('pointermove',e=>{
        if(!st.pan)return;e.preventDefault();
        const dx=e.clientX-st.sx,dy=e.clientY-st.sy;
        if(!st.moved&&(Math.abs(dx)>DRAG_THD||Math.abs(dy)>DRAG_THD))st.moved=true;
        st.x=dx;st.y=dy;
        if(!st.raf)st.raf=requestAnimationFrame(()=>{clamp();st.raf=null;});
      },{passive:false});

      img.addEventListener('pointerup',     ()=>{st.pan=false;img.style.cursor='grab';T(true);});
      img.addEventListener('pointercancel', ()=>{st.pan=false;T(true);});
    });

    const resetAll=()=>map.forEach((_,i)=>i.dispatchEvent(new Event('resetZoom')));
    document.querySelectorAll(SEL_ARROW).forEach(b=>b.addEventListener('click',resetAll));
    document.querySelectorAll(SEL_CLOSE).forEach(b=>b.addEventListener('click',resetAll));
  }

 /* =========== MOBILE =========== */
  function initMobile(){


    /* ── внутри модалки ── */
    document.querySelectorAll(SEL_MODAL).forEach(modal=>{

      modal.querySelectorAll('.zoom-media img').forEach(pic=>{
        const box = pic.closest('.zoom-item');           // рамка
        pic.style.transformOrigin = 'center center';     // ✔ всегда центр

        const st = { s:1,x:0,y:0,
                     base:1,d0:0,mid:null,
                     drag:false,sx:0,sy:0,
                     vx:0,vy:0,lastT:0,momID:null };

        /* helpers */
        const clamp=(v,min,max)=>Math.max(min,Math.min(v,max));
        const dist = t=>{const[a,b]=t;return Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY);};
        const mid  = t=>{const[a,b]=t;return{x:(a.clientX+b.clientX)/2,y:(a.clientY+b.clientY)/2};};

        const clampPan = ()=>{
          const c = box.getBoundingClientRect();
          const r = pic.getBoundingClientRect();
          const maxX = Math.max(0,(r.width -c.width )/2);
          const maxY = Math.max(0,(r.height-c.height)/2);
          st.x = clamp(st.x,-maxX,maxX);
          st.y = clamp(st.y,-maxY,maxY);
        };
        const render = ()=>{
          clampPan();
          pic.style.transform=`translate3d(${st.x}px,${st.y}px,0) scale(${st.s})`;
          modal.classList.toggle('disable-slider', st.s>1.01);
        };

        const stopMom = ()=>{ if(st.momID){cancelAnimationFrame(st.momID);st.momID=null;} };

        /* native-scroll-like momentum */
        const momentum = (t0)=>{
          if(!st.momID) return;
          const now = performance.now(), dt = now-t0;
          const dec = DECEL*dt;
          st.vx = adjustVel(st.vx, dec);
          st.vy = adjustVel(st.vy, dec);
          st.x += st.vx*dt; st.y += st.vy*dt;
          clampPan();
          pic.style.transform=`translate3d(${st.x}px,${st.y}px,0) scale(${st.s})`;
          if(Math.hypot(st.vx,st.vy) > MIN_V) st.momID=requestAnimationFrame(()=>momentum(now));
          else st.momID=null;
        };
        const adjustVel=(v,d)=> v>0?Math.max(0,v-d):Math.min(0,v+d);

        const reset = ()=>{ stopMom();st.s=1;st.x=st.y=0;render(); };
        pic.addEventListener('resetZoom',reset);

        /* touchstart */
        pic.addEventListener('touchstart',e=>{
          stopMom();
          if(e.touches.length===2){
            st.d0  = dist(e.touches);
            st.mid = mid(e.touches);
            st.base= st.s;
            pic.classList.add('no-transition');
          }else if(e.touches.length===1 && st.s>1){
            st.drag=true;
            st.sx = e.touches[0].clientX - st.x;
            st.sy = e.touches[0].clientY - st.y;
            st.vx=st.vy=0; st.lastT=e.timeStamp;
            pic.classList.add('no-transition');
          }
        },{passive:false});

        /* touchmove */
        pic.addEventListener('touchmove',e=>{
          if(e.touches.length===2 && st.d0){
            e.preventDefault();
            st.s = clamp(st.base * (dist(e.touches)/st.d0), MIN_S, MAX_S);
            const m = mid(e.touches);
            st.x += m.x - st.mid.x;
            st.y += m.y - st.mid.y;
            st.mid = m; render();
          }else if(st.drag && e.touches.length===1){
            e.preventDefault();
            const now=e.timeStamp||Date.now();
            const nx=e.touches[0].clientX-st.sx;
            const ny=e.touches[0].clientY-st.sy;
            if(now!==st.lastT){
              st.vx=(nx-st.x)/(now-st.lastT);
              st.vy=(ny-st.y)/(now-st.lastT);
            }
            st.lastT=now; st.x=nx; st.y=ny; render();
          }
        },{passive:false});

        /* touchend */
        pic.addEventListener('touchend',e=>{
          if(e.touches.length<2) st.d0=0;
          if(st.drag && e.touches.length===0){
            st.drag=false;
            if(Math.hypot(st.vx,st.vy) > MIN_V)
              st.momID=requestAnimationFrame(()=>momentum(performance.now()));
          }

          /* быстрый reset/close */
          if(e.changedTouches.length===2 && st.base>1){
            const delta=st.d0 - dist(e.changedTouches);
            if(delta>PINCH_RESET) reset();
            else if(st.s===1 && delta>PINCH_CLOSE){ closeModal(modal); return; }
          }
          if(st.s<=1.01){ reset(); }

          pic.classList.remove('no-transition');
        });

      });

      /* arrows / close */
      modal.querySelectorAll(SEL_CLOSE).forEach(b=>b.addEventListener('click',()=>closeModal(modal)));
      modal.querySelectorAll(SEL_ARROW).forEach(b=>b.addEventListener('click',()=>{
        modal.querySelectorAll('.zoom-media img')
             .forEach(i=>i.dispatchEvent(new Event('resetZoom')));
      }));
    });

    /* helpers */
    const dist = t=>{const[a,b]=t;return Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY);};
    const mid  = t=>{const[a,b]=t;return{x:(a.clientX+b.clientX)/2,y:(a.clientY+b.clientY)/2};};
    const openModal  = m=>m?.classList.add('is-active');
    const closeModal = m=>{m?.classList.remove('is-active');
      m?.querySelectorAll('.zoom-media img')
        .forEach(i=>i.dispatchEvent(new Event('resetZoom')));}
  }
});

/* intercept click on .product-media-zoom-link */
document.addEventListener('click',(e)=>{
  const link = e.target.closest('.product-media-zoom-link');
  if(!link) return;

  e.preventDefault();

  const targetId = link.dataset.zoomTarget;           // modal-item-…
  const modalSel = link.getAttribute('href');         // #modal--zoom-gallery-…
  const modal    = document.querySelector(modalSel);
  const track    = modal?.querySelector('.gridy-track');
  const item     = modal?.querySelector('#'+targetId);

  if(!modal||!track||!item) return;

  modal.classList.add('is-preparing');

  track.scrollLeft = item.offsetLeft - track.offsetLeft;

  requestAnimationFrame(()=>{
    modal.classList.remove('is-preparing');
    modal.classList.add   ('is-active');
  });
});

